import React from "react";
import "./AboutUs.scss";
import img1 from "../../img/img1.jpg"; // Left Image
import img2 from "../../img/img2.png"; // Center Image
import img3 from "../../img/img3.png"; // Right Image

const AboutUs = () => {
  return (
    <section className="about-us container py-5">
      {/* Header */}
      <div className="text-center mb-4">
        <h2 className="section-title">About Us</h2>
        <p className="subtitle">Decades of Dedication, Unwavering Quality.</p>
      </div>

      {/* Images Section */}
      <div className="row justify-content-center gx-4">
        <div className="col-md-3 col-12 d-flex justify-content-center">
          <div className="image-container">
            <img src={img1} alt="Left" className="about-image shadow" />
          </div>
        </div>
        <div className="col-md-3 col-12 d-flex justify-content-center">
          <div className="image-container">
            <img src={img2} alt="Center" className="about-image shadow" />
          </div>
        </div>
        <div className="col-md-3 col-12 d-flex justify-content-center">
          <div className="image-container">
            <img src={img3} alt="Right" className="about-image shadow" />
          </div>
        </div>
      </div>

      {/* Footer Text */}
      <div className="text-center mt-4 about-text">
        <p>
          For over 32 years, <strong>RAN GLOBAL AUTO ENGG PVT LTD</strong> has
          been a trusted partner in the automotive industry. Our legacy is built
          on precision engineering, advanced manufacturing, and a relentless
          pursuit of excellence.
        </p>
      </div>
    </section>
  );
};

export default AboutUs;
